import React from 'react'
import { ProtectedRoute } from 'components/ui-routing/ProtectedRoute'

export const lazyLoadRoute = (component: React.FC, permissions: string | string[]) => ({
  Component: () => <ProtectedRoute component={component} permissions={permissions} />,
})
